import { render, staticRenderFns } from "./CertificateSendList.vue?vue&type=template&id=37932121"
import script from "./CertificateSendList.vue?vue&type=script&lang=js"
export * from "./CertificateSendList.vue?vue&type=script&lang=js"
import style0 from "./CertificateSendList.vue?vue&type=style&index=0&id=37932121&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports